module.exports = __webpack_public_path__ + "static/media/policits_partners.47837a49.jpg";